import type { ReactNode } from 'react'

import { cn } from 'utils/classMerge'

import BaseModal from '../base-modal'
import ModalContent from '../modal-content'
import ModalTitle from '../modal-title'
import type { ModalProps, TailwindMaxWidth } from '..'

export interface LeftAlignedModalProps extends ModalProps {
  maxSize: TailwindMaxWidth
  footer?: ReactNode
  titleVariables?: string[]
  zIndex?: string
}

export default function LeftAlignedModal({
  isOpen,
  onClose,
  title,
  titleClassName,
  icon,
  closeButton,
  footer,
  content,
  maxSize,
  titleVariables,
  zIndex,
}: LeftAlignedModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      closeButton={closeButton}
      maxSize={maxSize}
      zIndex={zIndex}
    >
      <div className="tw-flex tw-flex-col tw-gap-4 tw-p-6">
        {title && (
          <ModalTitle
            text={title}
            icon={icon}
            orientation="left"
            customTextStyle={titleClassName}
            titleVariables={titleVariables}
          />
        )}
        <ModalContent
          orientation="left"
          className={cn({
            'sm:tw-ml-12': Boolean(icon),
          })}
        >
          {content}
        </ModalContent>
        {footer && (
          <>
            <hr className="tw-hidden sm:tw--mx-6 sm:tw-block  sm:tw-border-t sm:tw-border-black/10" />
            {footer}
          </>
        )}
      </div>
    </BaseModal>
  )
}
